import { useMemo } from "react";
import { useUserPreferences } from "@/features/user-preferences";
import { useDataModelContext } from "@/entities/data-model";
import { useMetadataQuery } from "@/entities/form-metadata";
import { useUserPreferencesQuery } from "@/entities/user-preferences";
import { usePageContextQuery } from "@/shared/page-context";
import { mapDataModelToFormValues } from "../metadata-converters/mapDataModelToFormValues";
import { populateFormValuesFromMetadata } from "../metadata-converters/populateFormValuesFromMetadata";

interface UseDefaultFormValuesArgs {
    isEditForm?: boolean;
}

export const useDefaultFormValues = ({ isEditForm = false }: UseDefaultFormValuesArgs) => {
    const dataModel = useDataModelContext();
    const { data: formMetadata } = useMetadataQuery();
    const { data: pageContext } = usePageContextQuery();

    const { data: userPreference } = useUserPreferencesQuery();
    const dataModelWithUps = useUserPreferences({ dataModel, formMetadata, isEditForm });
    const matchAllTermsExactly = userPreference?.matchAllTermsExactly ?? false;
    const defaultYearProximity = pageContext.runtimeConfig.defaultYearProximity;

    return useMemo(() => {
        const sourceFormValues = mapDataModelToFormValues(dataModelWithUps);
        return populateFormValuesFromMetadata({
            isEditForm,
            matchAllTermsExactly,
            formMetadata,
            sourceFormValues,
            defaultYearProximity,
        });
    }, [dataModelWithUps, formMetadata, isEditForm, matchAllTermsExactly, defaultYearProximity]);
};
